import { render, staticRenderFns } from "./CoachCompanyInvitation.vue?vue&type=template&id=42a405ee&scoped=true"
import script from "./CoachCompanyInvitation.vue?vue&type=script&lang=js"
export * from "./CoachCompanyInvitation.vue?vue&type=script&lang=js"
import style0 from "./CoachCompanyInvitation.vue?vue&type=style&index=0&id=42a405ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a405ee",
  null
  
)

export default component.exports